import { render, staticRenderFns } from "./Germany.vue?vue&type=template&id=2157143a&"
import script from "./Germany.vue?vue&type=script&lang=js&"
export * from "./Germany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2157143a')) {
      api.createRecord('2157143a', component.options)
    } else {
      api.reload('2157143a', component.options)
    }
    module.hot.accept("./Germany.vue?vue&type=template&id=2157143a&", function () {
      api.rerender('2157143a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Germany.vue"
export default component.exports